// Even though we have a `global-error.tsx` it is still recommended to have a root error.tsx:
// https://nextjs.org/docs/app/building-your-application/routing/error-handling

"use client" // Error components must be Client Components

import { useEffect, useState } from "react"
import { GenericErrorMessage } from "@/components/GenericErrorMessage/GenericErrorMessage.component"
import { useCaptureException } from "@/hooks/use-capture-exception.hook"
import { captureClientException } from "@/services/logging/capture-client-exception"
import type { Locale } from "@/ts/locale/locale.types"
import { getCurrentSiteConfiguration } from "@/utilities/site-configuration/get-current-site-configuration"

export default function Error({
  error,
  reset,
}: {
  readonly error: Error & { readonly digest?: string }
  readonly reset: () => void
}) {
  const [locale, setLocale] = useState<Locale>("en")

  useCaptureException(error)

  useEffect(() => {
    const grabLocale = async () => {
      const { locale } = await getCurrentSiteConfiguration()
      setLocale(locale)
    }

    grabLocale().catch(captureClientException)
  }, [])

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-whisper">
      <GenericErrorMessage
        locale={locale !== null ? locale : "en"}
        reset={reset}
      />
    </div>
  )
}
